/**
 * Single source for site-wide constants.
 *
 * CONTACT_EMAIL is the owner-confirmed public contact address. It is defined
 * ONCE here; every page/component imports it. To change the public address,
 * edit this one line.
 */
export const CONTACT_EMAIL = 'faircorp.info@gmail.com';

/** Correctly formed mailto: link; optional subject. */
export function mailto(subject?: string): string {
  return subject
    ? `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`
    : `mailto:${CONTACT_EMAIL}`;
}

/**
 * The Hub carries no hosting information. Hosting customers are routed to the
 * dedicated Hosting storefront via a plain outbound link.
 */
export const HOSTING_URL: string =
  import.meta.env.VITE_HOSTING_URL ?? 'https://hosting.fair-corp.com';

/**
 * Development quotes are produced on the specialized site. Every "get a
 * quote" call-to-action goes straight to its /pricing page — the Hub has no prices or tier names of its own. The origin follows
 * VITE_HOSTING_URL; no visitor data is passed.
 */
function pricingUrl(base: string): string {
  try {
    return `${new URL(base).origin}/pricing`;
  } catch {
    return 'https://hosting.fair-corp.com/pricing';
  }
}
export const QUOTE_URL: string = pricingUrl(HOSTING_URL);

export const LINKEDIN_URL = 'https://www.linkedin.com/company/fair-corp/';
